import React from 'react';
import { useAddSubscriptionRestrictionComponent } from './useAddSubscriptionRestrictionComponent';
import { Box, Grid } from '@mui/material';
import AppFormSelectWrapper from '../../../../components/designe/app-form-select-wrapper';
import { useTranslation } from 'react-i18next';
import AppButton from '../../../../components/designe/app-button/AppButton';
import { useStyles } from './AddSubscriptionRestriction.styles';
import theme from '../../../../styles/theme';
import { ISubscriptionRestriction } from '../../../../types/interfaces/subscription-restriction';
import {
  RestrictionScope,
  SubscriptionPeriod,
  SubscriptionScope,
  SubscriptionType,
} from '../../../../shared/constants';
import AppFormTextField from '../../../../components/designe/app-form-text-field';

interface IAddSubscriptionRestrictionProps {
  subscriptionRestriction: ISubscriptionRestriction;
  onClose: () => void;
}

export default function AddSubscriptionRestriction(
  props: IAddSubscriptionRestrictionProps,
) {
  const { subscriptionRestriction, onClose } = props;
  const { t } = useTranslation();
  const { formik, isLoading } = useAddSubscriptionRestrictionComponent(
    onClose,
    subscriptionRestriction,
  );
  const { classes } = useStyles(theme);
  const subscriptionTypeOptions = [
    {
      id: SubscriptionType.free,
      name: t(`superAdminDashboard.subscriptionType_${SubscriptionType.free}`),
    },
    {
      id: SubscriptionType.starter,
      name: t(
        `superAdminDashboard.subscriptionType_${SubscriptionScope.starter}`,
      ),
    },
    {
      id: SubscriptionType.pro,
      name: t(`superAdminDashboard.subscriptionType_${SubscriptionScope.pro}`),
    },
    {
      id: SubscriptionType.trainer,
      name: t(
        `superAdminDashboard.subscriptionType_${SubscriptionScope.trainer}`,
      ),
    },
  ];

  const restrictionScopeOptions = [
    {
      id: RestrictionScope.exercise,
      name: t(
        `superAdminDashboard.restrictionScope_${RestrictionScope.exercise}`,
      ),
    },

    {
      id: RestrictionScope.program,
      name: t(
        `superAdminDashboard.restrictionScope_${RestrictionScope.program}`,
      ),
    },
    {
      id: RestrictionScope.programItem,
      name: t(
        `superAdminDashboard.restrictionScope_${RestrictionScope.programItem}`,
      ),
    },
    {
      id: RestrictionScope.training,
      name: t(
        `superAdminDashboard.restrictionScope_${RestrictionScope.training}`,
      ),
    },
    {
      id: RestrictionScope.trainingGeneration,
      name: t(
        `superAdminDashboard.restrictionScope_${RestrictionScope.trainingGeneration}`,
      ),
    },
    {
      id: RestrictionScope.periodStatistics,
      name: t(
        `superAdminDashboard.restrictionScope_${RestrictionScope.periodStatistics}`,
      ),
    },
  ];

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <AppFormSelectWrapper
              label={t('common.type')}
              name="type"
              showSearch={false}
              disableClear
              options={subscriptionTypeOptions}
              defaultValue={subscriptionTypeOptions?.find(
                (r) => r.id === formik.values.type,
              )}
              onChange={(e) => formik.setFieldValue('type', e.target.value.id)}
              formik={formik}></AppFormSelectWrapper>
          </Grid>
          <Grid item sm={12}>
            <AppFormSelectWrapper
              label={t('superAdminDashboard.restrictionScope')}
              name="restrictionScope"
              showSearch={false}
              disableClear
              options={restrictionScopeOptions}
              defaultValue={restrictionScopeOptions?.find(
                (r) => r.id === formik.values.restrictionScope,
              )}
              onChange={(e) =>
                formik.setFieldValue('restrictionScope', e.target.value.id)
              }
              formik={formik}></AppFormSelectWrapper>
          </Grid>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.maxValue')}
              fullWidth
              name="maxValue"
              type="number"
              formik={formik}
            />
          </Grid>
        </Grid>
        <Box className={classes.addSubscriptionRestrictionsButtonWrapper}>
          <AppButton variant="outlined" onClick={() => onClose()}>
            {t('common.cancel')}
          </AppButton>
          <AppButton type="submit" loader={isLoading}>
            {subscriptionRestriction ? t('common.update') : t('common.create')}
          </AppButton>
        </Box>
      </form>
    </Box>
  );
}
